import { Modal, Popover, Tooltip } from '@mui/material';
import { RenameQuery } from './RenameQuery';
import { FiltersContainer } from '../Filters/FiltersContainer';
import { useState, useEffect, useRef } from 'react';
import { UpgradeModal } from '../../../components/UpgradeModal/UpgradeModal';
import { AutoRefreshStatus } from './AutoRefreshStatus';

export const EvScreenControlButtons = (props) => {
	const {
		isMobile,
		isScannable,
		executeEvScreen,
		play_icon,
		setIsAutoRefresh,
		isAutoRefresh,
		lastRefreshedAt,
		isLive,
		setIsFiltersOpen,
		setIsFiltersSetAnchorEl,
		setIsLive,
		setIsFilterSetOpen,
		isFilterSetOpen,
		isFilterSetModalOpen,
		setIsFilterSetModalOpen,
		user,
		setUser,
		eye_icon,
		isFiltersSetAnchorEl,
		queries,
		setQueries,
		setFilters,
		newQueryName,
		setNewQueryName,
		newQueryNameRef,
		edit_icon,
		setFiltersOpen,
		filtersOpen,
		setIsPlacedUnplacedOpen,
		setIsPlacedAnchorEl,
		isPlacedUnplacedOpen,
		lightbulb_icon,
		allBetsOpen,
		setAllBetsOpen,
		isPlacedAnchorEl,
		isFiltersOpen,
		filter_icon,
	} = props;
	const isMasterOrOracle =
		(user?.stripe_plan?.nickname?.includes('Visionary') && user?.stripe_plan.active&& user?.stripe_subscription !== null && user?.stripe_status !== 'deleted' && user.stripe_status !== 'past_due') ||
		(user?.stripe_plan?.nickname?.includes('Oracle') && user?.stripe_plan.active&& user?.stripe_subscription !== null && user?.stripe_status !== 'deleted' && user.stripe_status !== 'past_due');

	const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

	useEffect(() => {
		const handleEscapeKey = (event) => {
			if (event.key === 'Escape') {
				setIsFiltersOpen(false);
				setFiltersOpen(null);
				setIsPlacedUnplacedOpen(false);
			}
		};

		document.addEventListener('keydown', handleEscapeKey);

		return () => {
			document.removeEventListener('keydown', handleEscapeKey);
		};
	}, [setIsFiltersOpen, setFiltersOpen, setIsPlacedUnplacedOpen]);


	const handleAutoRefreshChange = (checked) => {
		if (!isMasterOrOracle) {
			setIsUpgradeModalOpen(true);
			return;
		}
		setIsAutoRefresh(checked);
	};

	return (
		<div style={{ marginLeft: isMobile ? 16 : 0 }} className="mt-4 flex flex-row justify-between items-end buttons-container">
			{/* Left side: Scan and Auto Refresh */}
			<div className="flex items-end gap-4">
				<Tooltip title={!isScannable ? `Finish selecting filters.` : ''}>
					<button
						onClick={async () => {
							if (isScannable) {
								setFiltersOpen(false)
								await executeEvScreen();
							}
						}}
						disabled={!isScannable}
						className={`flex items-center justify-center h-14 px-6 rounded-2xl text-white text-lg font-medium transition-all ${
							isScannable 
								? 'bg-[#0064f2] hover:bg-[#5d97f6] cursor-pointer' 
								: 'bg-[#7a8299] hover:bg-[#aaaeb8] cursor-default'
						}`}
						style={{
							userSelect: 'none',
							WebkitUserSelect: 'none',
							MozUserSelect: 'none',
							msUserSelect: 'none'
						}}>
						<img src={play_icon} alt="play icon" className="mr-2" />
						Scan
					</button>
				</Tooltip>

				<div style={{ position: 'relative' }}>
					<button
						onClick={() => {
							if (isMasterOrOracle) {
								handleAutoRefreshChange(!isAutoRefresh);
							} else {
								setIsUpgradeModalOpen(true);
							}
						}}
						className={`flex items-center justify-center h-14 px-6 rounded-2xl text-white text-base font-normal transition-all ${
							isMasterOrOracle && isAutoRefresh
								? 'bg-[#1e3a5f] border border-[#0064f2]'
								: 'bg-[#22262e] border border-transparent'
						}`}
						style={{
							userSelect: 'none',
							WebkitUserSelect: 'none',
							MozUserSelect: 'none',
							msUserSelect: 'none'
						}}>
						Auto Refresh
					</button>
					<div style={{ position: 'absolute', top: '100%', left: 0, right: 0, display: 'flex', justifyContent: 'center' }}>
						<AutoRefreshStatus isAutoRefresh={isMasterOrOracle && isAutoRefresh} lastRefreshedAt={lastRefreshedAt} />
					</div>
				</div>
			</div>

			{/* Center: Pregame/Live buttons */}
			<div className="flex flex-row rounded-2xl" style={{ 
				backgroundColor: '#22262e',
				paddingTop: 8,
				paddingBottom: 8,
				paddingLeft: 10,
				paddingRight: 10
			}}>
				<div onClick={() => setIsLive(false)} className={`cursor-pointer p-2 mr-4 ${!isLive && 'filter-button-highlighted'}`}>
					Pregame
				</div>
				<div
					onClick={() => {
						if (isMasterOrOracle) {
							setIsLive(true);
						} else {
							setIsUpgradeModalOpen(true);
						}
					}}
					className={`cursor-pointer p-2  ${isLive && 'filter-button-highlighted'}`}>
					Live
				</div>
				<UpgradeModal isOpen={isUpgradeModalOpen} setIsOpen={setIsUpgradeModalOpen} />
			</div>

			{/* Right side: All Bets and Customize */}
			<div className="flex flex-row items-end" style={{ gap: '8px' }}>
				<div
					onClick={(e) => {
						setIsPlacedAnchorEl(e.currentTarget);
						setIsPlacedUnplacedOpen(!isPlacedUnplacedOpen);
					}}
					className="flex flex-row rounded-2xl cursor-pointer items-center"
					style={{
						borderBottomLeftRadius: isPlacedUnplacedOpen ? 0 : '1rem',
						borderBottomRightRadius: isPlacedUnplacedOpen ? 0 : '1rem',
						width: 170,
						minWidth: 150,
						justifyContent: 'center',
						backgroundColor: '#22262e',
						paddingTop: 8,
						paddingBottom: 8,
						paddingLeft: 10,
						paddingRight: 10
					}}>
					<img width={25} src={lightbulb_icon} alt="icon" />
					<div className="p-2">
						{allBetsOpen === 'all' && 'All Bets'}

						{allBetsOpen === 'unplaced' && 'Unplaced Bets'}
						{allBetsOpen === 'placed' && 'Placed Bets'}
					</div>
					<Popover
						anchorEl={isPlacedAnchorEl}
						open={isPlacedUnplacedOpen}
						onClose={() => {
							setIsPlacedUnplacedOpen(false);
						}}
						sx={{
							'& .MuiPaper-root': {
								backgroundColor: '#22262e',
								borderTopRightRadius: '1rem',
								borderBottomLeftRadius: '1rem',
								borderBottomRightRadius: '1rem',
							},
						}}
						anchorOrigin={{ vertical: 'bottom' }}>
						<div className="rounded-2xl" style={{ backgroundColor: '#22262e', width: 190 }}>
							<div
								onClick={() => {
									setAllBetsOpen('all');
								}}
								className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'all' && 'filter-button-highlighted'}`}
								style={{ color: 'white', borderTopLeftRadius: '1rem', borderTopRightRadius: '1rem' }}>
								All Bets
							</div>
							<div
								onClick={() => {
									setAllBetsOpen('unplaced');
								}}
								className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'unplaced' && 'filter-button-highlighted'}`}
								style={{ color: 'white' }}>
								Unplaced Bets
							</div>
							<div
								onClick={() => {
									setAllBetsOpen('placed');
								}}
								className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'placed' && 'filter-button-highlighted'}`}
								style={{ color: 'white', borderBottomLeftRadius: '1rem', borderBottomRightRadius: '1rem' }}>
								Placed Bets
							</div>
						</div>
					</Popover>
				</div>
				<div
					onClick={() => {
						setIsFiltersOpen(!isFiltersOpen);
						setFiltersOpen(filtersOpen ? null : 'website');
					}}
					className={`rounded-2xl cursor-pointer flex flex-row items-center ${isFiltersOpen && 'filter-button-highlighted'} filter-button-tutorial`}
					style={{ 
						flexShrink: 0,
						backgroundColor: isFiltersOpen ? '#363844' : '#22262e',
						paddingTop: 8,
						paddingBottom: 8,
						paddingLeft: 10,
						paddingRight: 10
					}}>
					<img src={filter_icon} alt="filter icon" />
					<div className="p-2">Customize</div>
				</div>
			</div>
		</div>
	);
};
